import React, { useState } from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import "./styles.less";

export const PartnerRight = () => {
  const { t } = useTranslation();
  const equityDataTop = [
    {
      img: "//files.authing.co/authing-website/equity-discout.svg",
      text: t("partner.equity.item1"),
    },
    {
      img: "//files.authing.co/authing-website/equity-support.svg",
      text: t("partner.equity.item2"),
    },
  ];
  const equityDataBottom = [
    {
      img: "//files.authing.co/authing-website/equity-train.svg",
      text: t("partner.equity.item5"),
    },
    {
      img: "//files.authing.co/authing-website/equity-rebate.svg",
      text: t("partner.equity.item6.title"),
      extra: t("partner.equity.item6.extra"),
    },
  ];
  return (
    <div>
      <section className="partner-equity">
        <div className="equity-card-warp">
          {equityDataTop.map((item, index) => (
            <div className="equity-card" key={index}>
              <div className="card-img">
                <img src={item.img} alt="authing" />
              </div>
              <div className="card-title">{item.text}</div>
            </div>
          ))}
        </div>
        <div className="equity-card-warp circle">
          <div className="equity-card">
            <div className="card-img">
              <img
                src="//files.authing.co/authing-website/equity-team.svg"
                alt="authing"
              />
            </div>
            <div className="card-title">{t("partner.equity.item3")}</div>
          </div>
          <div className="equity-circle">
            <div className="card-title">
              {t("partner.equity.title1")}
              <br />
              {t("partner.equity.title2")}
            </div>
          </div>
          <div className="equity-card">
            <div className="card-img">
              <img
                src="//files.authing.co/authing-website/equity-emit.svg"
                alt="authing"
              />
            </div>
            <div className="card-title">{t("partner.equity.item4")}</div>
          </div>
        </div>
        <div className="equity-card-warp">
          {equityDataBottom.map((item, index) => (
            <div className="equity-card" key={index}>
              <div className="card-img">
                <img src={item.img} alt="authing" />
              </div>
              <div className="card-title">{item.text}</div>
              {item.extra && <div className="card-extra">{item.extra}</div>}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};
